(function() {
  function initAllFeaturedCarousels() {
    const carousels = document.querySelectorAll('[data-featured-carousel]');
    
    carousels.forEach(function(carouselEl) {
      // Skip if already initialized
      if (carouselEl._flickity) {
        try {
          carouselEl._flickity.resize();
        } catch(e) {}
        return;
      }

      // Initialize Flickity
      const flickityInstance = new Flickity(carouselEl, {
        selectedAttraction: 0.12,
        friction: 0.9,
        imagesLoaded: true,
        groupCells: "100%",
        cellAlign: "left",
        prevNextButtons: true,
        wrapAround: false,
        pageDots: false,
        resize: true,
      });

      // Store instance on element
      carouselEl._flickity = flickityInstance;
      flickityInstance.resize();

      // Set up card heights for this carousel
      const sliderCards = carouselEl.querySelectorAll('.carousel-cell');
      const sliderCardsWrappers = carouselEl.querySelectorAll('.carousel-cell .card-wrapper');

      sliderCards.forEach(function(card) {
        card.style.height = "100%";
      });
      sliderCardsWrappers.forEach(function(card) {
        card.style.height = "100%";
      });

      // Handle resize for this carousel
      const handleResize = function() {
        sliderCards.forEach(function(card) {
          card.style.height = "fit-content";
        });
        sliderCardsWrappers.forEach(function(card) {
          card.style.height = "fit-content";
        });
        
        if (carouselEl._flickity) {
          try {
            carouselEl._flickity.resize();
          } catch(e) {}
        }

        sliderCards.forEach(function(card) {
          card.style.height = "100%";
        });
        sliderCardsWrappers.forEach(function(card) {
          card.style.height = "100%";
        });
      };

      // Debounced resize handler
      let resizeTimeout;
      window.addEventListener("resize", function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(handleResize, 100);
      });
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllFeaturedCarousels);
  } else {
    initAllFeaturedCarousels();
  }

  // Shopify Theme Editor support
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initAllFeaturedCarousels);
    document.addEventListener('shopify:section:select', initAllFeaturedCarousels);
    document.addEventListener('shopify:block:select', initAllFeaturedCarousels);
  }
})();
